module.exports = __webpack_public_path__ + "media/images/pic/anime/cup-of-coffee-36a4957cf370c381e517c601c4947993.svg";